import type { TranslationKey } from "../lib/i18n";

export interface IToolbarItem {
  key: string;
  page: string;
  labelKey: TranslationKey;
  titleKey: TranslationKey;
}

const ToolbarSettings: IToolbarItem[] = [
  {
    key: "treatments",
    page: "treatments",
    labelKey: "nav.treatments",
    titleKey: "nav.treatments",
  },
  {
    key: "journal",
    page: "journal",
    labelKey: "nav.journal",
    titleKey: "nav.journal",
  },
  {
    key: "contact",
    page: "contact",
    labelKey: "nav.contact",
    titleKey: "nav.contact",
  },
  {
    key: "gift-card",
    page: "gift-card",
    labelKey: "nav.giftcard",
    titleKey: "nav.giftcard",
  },
  {
    key: "booking",
    page: "booking",
    labelKey: "nav.booking",
    titleKey: "nav.booking",
  },
];

export default ToolbarSettings;
